
import NoticiaSliderComponent from "@/components/Common/CarouselSlider/NoticiaSliderComponent.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Notify } from "quasar";

@Component({
  components: {
    NoticiaSliderComponent
  }
})
export default class NoticiasCarouselComponent extends Vue {
  @Prop({ type: Array, required: true }) noticias!: any[];
  private slide: String = "1";
}
